// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { myListsViewStyles } from "@insite/content-library/Widgets/MyLists/MyListsView";
import { SelectProps } from "@insite/mobius/Select";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myListsViewStyles.select = {
    labelPosition: "top",
    label: translate("Show"),
    preventEllipsis: true,
    sizeVariant: "default",
    cssOverrides: {
        formInputWrapper: css`
            width: 204px;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    },
} as SelectProps;
